module.exports = __webpack_public_path__ + "img/Henan-speed.673de3ab.png";